import React, { useState } from 'react';
import { actionHistory } from '../../mock';
import { CheckCircle2, Info, Minus, Filter } from 'lucide-react';
import { cn } from '../../lib/utils';

export default function ActionHistory() {
  const [filter, setFilter] = useState('all');
  const filtered = filter === 'all' ? actionHistory : actionHistory.filter((a) => a.type === filter);

  return (
    <div className="rounded-2xl border hairline bg-white p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-[10.5px] uppercase tracking-[0.22em] text-neutral-500 font-bold">Activity</div>
          <h3 className="display text-[18px] font-bold text-neutral-900 tracking-tight">Action History</h3>
        </div>
        <div className="flex items-center gap-1 rounded-lg border hairline p-0.5 bg-white">
          {['all', 'success', 'info'].map((k) => (
            <button
              key={k}
              onClick={() => setFilter(k)}
              className={cn(
                'text-[10.5px] font-bold px-2.5 py-1 rounded-md capitalize transition',
                filter === k ? 'bg-neutral-900 text-white' : 'text-neutral-500 hover:text-neutral-900'
              )}
            >
              {k === 'all' ? <span className="flex items-center gap-1"><Filter className="h-3 w-3" /> All</span> : k}
            </button>
          ))}
        </div>
      </div>

      <ol className="relative border-l border-neutral-200 ml-2 space-y-3">
        {filtered.map((a, i) => (
          <li key={i} className="pl-5 relative">
            <span className="absolute -left-[7px] top-2 h-3 w-3 rounded-full bg-white border border-neutral-300 flex items-center justify-center">
              {a.type === 'success' ? (
                <span className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--kf-gold))]" />
              ) : a.type === 'info' ? (
                <span className="h-1.5 w-1.5 rounded-full bg-neutral-900" />
              ) : (
                <span className="h-1.5 w-1.5 rounded-full bg-neutral-300" />
              )}
            </span>
            <div className="rounded-lg border hairline hover:border-neutral-400 bg-white px-3 py-2.5 card-lift">
              <div className="flex items-center justify-between gap-3">
                <div className="text-[12.5px] font-bold text-neutral-900">{a.action}</div>
                <div className="mono text-[10.5px] text-neutral-500 shrink-0">{a.date}</div>
              </div>
              <div className="text-[10.5px] text-neutral-500 mt-0.5">{a.actor}</div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
